var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qb-panel',{attrs:{"title":"Title","buttonTitle":"Carregar mais"}},[_c('qb-card',{attrs:{"get":"products","button":true,"modal":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }